<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content mb-4">
        <div class="row position-relative">
          <div class="col-12 col-md-6 mt-md-5 px-0 px-md-3 position-relative">
            <slot name="image-carousel"></slot>

            <!-- Mobile Tag Row in image area -->
            <div
              class="fs-tag-row fs-tag-row-mobile d-flex align-items-center d-md-none"
              v-if="savingMoneyPercent > 0 || campaignBadgeValue"
            >
              <div
                class="fs-discount-badge bg-danger border-radius px-3 py-2 font-weight-bold d-inline-flex align-items-center justify-content-center mr-2"
                v-if="savingMoneyPercent > 0"
              >
                <span>-{{ Math.floor(savingMoneyPercent) }}%</span>
              </div>
              <div class="fs-campaign-badge border-radius px-3 py-2 text-uppercase font-weight-bold d-inline-flex align-items-center" v-if="campaignBadgeValue">
                <span>{{ campaignBadgeValue }}</span>
              </div>
            </div>
            <!-- /Mobile Tag Row -->

            <div class="fs-saving d-none bg-danger text-white border-radius p-2 position-absolute" v-if="savingMoneyPercent > 0">
              <span>-{{ Math.floor(savingMoneyPercent) }}%</span>
            </div>

            <template v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0">
              <div v-for="variationPropertyGroups in getBadgeProperties" :key="variationPropertyGroups.id">
                <div v-for="badgeProperty in variationPropertyGroups.properties" :key="badgeProperty.id">
                  <template v-if="badgeProperty.id === 266">
                    <div class="fs-badge position-absolute">
                      <img :src="$translate('HuGVueTheme::SingleItemTheme.BadgeImg')" :alt="$translate('HuGVueTheme::SingleItemTheme.BadgeAltText')" class="img-fluid" />
                    </div>
                  </template>
                </div>
              </div>
            </template>

            <template v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0">
              <div v-for="variationPropertyGroups in getVideoProperties" :key="variationPropertyGroups.id">
                <button
                  type="button"
                  class="btn btn-primary fs-video-btn border-radius font-weight-bold align-items-center d-none d-md-inline-flex mt-2"
                  data-toggle="modal"
                  data-target="#product-video"
                  v-html="$translate('HuGVueTheme::SingleItemTheme.ModalButtonText')"
                ></button>

                <!-- Modal -->
                <div class="modal fade" id="product-video" tabindex="-1" role="dialog" aria-labelledby="product-video" aria-hidden="true">
                  <div class="modal-dialog" role="document">
                    <div class="modal-content">
                      <div class="modal-header">
                        <p class="modal-title h5" id="product-video-label" v-html="$translate('HuGVueTheme::SingleItemTheme.ModalHeadline')"></p>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body">
                        <div class="container-max px-0">
                          <div class="row">
                            <div v-for="variationProperty in variationPropertyGroups.properties" :key="variationProperty.id" class="col-12 col-md-6 mb-3">
                              <video controls :poster="$translate('HuGVueTheme::SingleItemTheme.ModalDefaulImage')">
                                <source :src="variationProperty.values.value" type="video/mp4" />
                              </video>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" v-html="$translate('HuGVueTheme::SingleItemTheme.ModalClose')"></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div class="col-12 col-md-6 mt-md-5 px-0 px-md-3">
            <div>
              <!-- START SINGLEITEM_DETAILS -->

              <!-- Tag Row -->
              <div
                class="fs-tag-row d-none d-md-flex align-items-center px-3 px-md-0 mt-3 mt-md-0 mb-2"
                v-if="savingMoneyPercent > 0 || campaignBadgeValue"
              >
                <div
                  class="fs-discount-badge bg-danger border-radius px-3 py-2 font-weight-bold d-inline-flex align-items-center justify-content-center mr-2"
                  v-if="savingMoneyPercent > 0"
                >
                  <span>-{{ Math.floor(savingMoneyPercent) }}%</span>
                </div>
                <div class="fs-campaign-badge border-radius px-3 py-2 text-uppercase font-weight-bold d-inline-flex align-items-center" v-if="campaignBadgeValue">
                  <span>{{ campaignBadgeValue }}</span>
                </div>
              </div>
              <!-- /Tag Row -->

              <h1 class="h4 title font-weight-bold mt-3 mt-lg-0 mb-2 px-3 px-md-0 pt-3 pt-md-0" data-testing="item-name">
                <span>{{ currentVariation | itemName }}</span>
              </h1>

              <!-- Static Rating -->
              <div class="fs-rating-row d-flex align-items-center px-3 px-md-0 mb-3">
                <div class="d-flex align-items-center text-warning" aria-hidden="true">
                  <i class="fa fa-star mr-1"></i>
                  <i class="fa fa-star mr-1"></i>
                  <i class="fa fa-star mr-1"></i>
                  <i class="fa fa-star mr-1"></i>
                  <i class="fa fa-star mr-1"></i>
                </div>
                <span class="font-weight-bold">{{ $translate("HuGVueTheme::SingleItemTheme.RatingText") }}</span>
              </div>
              <!-- /Static Rating -->

              <!-- BuyBox -->
              <div class="buy-box pt-4 p-3 border-radius">
                <div class="single-usp d-flex w-100 justify-content-between align-items-center">
                  <slot name="fs-usps">
                    <ul class="list-unstyled m-0">
                      <li>
                        <span class="font-weight-bold text-center" v-html="$translate('HuGVueTheme::SingleItemTheme.Usp1')"></span>
                      </li>
                      <li>
                        <span class="font-weight-bold text-center" v-html="$translate('HuGVueTheme::SingleItemTheme.Usp2')"></span>
                      </li>
                      <li>
                        <span class="font-weight-bold text-center" v-html="$translate('HuGVueTheme::SingleItemTheme.Usp3')"></span>
                      </li>
                      <li v-if="isUsp4Visible">
                        <span class="d-none font-weight-bold text-center" v-html="$translate('HuGVueTheme::SingleItemTheme.Usp4')"></span>
                      </li>
                    </ul>
                  </slot>

                  <div class="manufacturer ml-auto">
                    <template v-if="currentVariation.filter.hasManufacturer">
                      <a v-if="currentVariation.item.manufacturer.url != ''" :href="currentVariation.item.manufacturer.url">
                        <img
                          v-if="currentVariation.item.manufacturer.logo != ''"
                          :alt="currentVariation.item.manufacturer.externalName"
                          :src="currentVariation.item.manufacturer.logo"
                          class="img-fluid"
                          width="120"
                        />
                        <p v-else class="" v-html="currentVariation.item.manufacturer.externalName"></p>
                      </a>
                      <template v-else>
                        <img
                          v-if="currentVariation.item.manufacturer.logo != ''"
                          :alt="currentVariation.item.manufacturer.externalName"
                          :src="currentVariation.item.manufacturer.logo"
                          class="img-fluid"
                          width="120"
                        />
                        <p v-else class="" v-html="currentVariation.item.manufacturer.externalName"></p>
                      </template>
                    </template>
                  </div>
                </div>

                <!-- Variation -->
                <div class="mt-3" v-if="hasPrimaryVariationSelector">
                  <variation-select></variation-select>
                </div>
                <!-- /Variation -->

                <!-- Item Bundle -->
                <item-bundle
                  v-if="currentVariation.variation.bundleType === 'bundle'"
                  :bundle-type="currentVariation.variation.bundleType"
                  :bundle-components="currentVariation.bundleComponents"
                ></item-bundle>
                <!-- /Item Bundle -->

                <slot name="before-price"></slot>

                <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                  <order-property-list></order-property-list>
                </div>

                <graduated-prices></graduated-prices>

                <div class="fs-pricing-availability d-flex w-100 justify-content-between align-items-end">
                  <!-- Shipping Info -->
                  <div class="fs-availability d-flex flex-wrap align-items-center">
                    <item-availability></item-availability>
                    <span
                      class="pl-0 pl-lg-2 mb-2 mb-lg-0 custom border-radius font-weight-bold d-flex align-items-center mr-1 small"
                      :class="'availability-' + getDataField('variation.availability.id')"
                      v-if="availabilityDisplayText"
                      v-html="availabilityDisplayText"
                    ></span>
                    <div class="fs-shipping-meta d-flex w-100 justify-content-between align-items-center mt-1">
                      <span class="shipping small text-muted" v-html="$translate('HuGVueTheme::SingleItemTheme.Shipping')"></span>
                    </div>
                  </div>
                  <!-- /Shipping Info -->

                  <!-- Price and Crossprice -->
                  <div class="fs-price text-right d-flex flex-column justify-content-end align-items-end">
                    <div class="fs-savings-text mb-2 font-weight-bold" v-if="savingMoneyPercent > 0">
                      Du sparst {{ Math.floor(savingMoneyPercent) }}%
                    </div>
                    <item-price :show-cross-price="isRecommendedPriceActive"></item-price>
                    
                    <!-- VAT -->
                    <div class="fs-price-meta d-flex w-100 justify-content-end align-items-center mt-1">
                      <template v-if="$store.state.basket.data.shippingCountryId === 1">
                        <span class="vat small id-1 text-muted" v-html="$translate('HuGVueTheme::SingleItemTheme.Vat')"></span>
                      </template>
                      <template v-else>
                        <span class="vat small id-else text-muted excl" v-html="$translate('HuGVueTheme::SingleItemTheme.ExclVat')"></span>
                      </template>
                    </div>
                    <!-- /VAT -->
                  </div>
                  <!-- /Price and Crossprice -->
                </div>

                <!-- EASYCREDIT -->
                <div class="d-flex justify-content-end" v-if="hydrated">
                  <button type="button" class="fs-easycredit-inline p-0" data-ec-open>
                    <img
                      alt="easyCredit Logo"
                      src="https://ratenkauf.easycredit.de/api/resource/webcomponents/v3/easycredit-components/assets/easycredit-supersign.svg"
                    />
                    <span class="fs-easycredit-textlink">Ratenzahlung mit easyCredit</span>
                  </button>
                </div>
                <!-- /EASYCREDIT -->

                <slot name="after-price"></slot>

                <div class="fs-button">
                  <div class="w-100">
                    <slot name="before-add-to-basket"></slot>
                  </div>

                  <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                    {{ $translate("Ceres::Template.singleItemSetInfo") }}
                  </div>
                  <div v-else class="col-12 my-3 px-0">
                    <div ref="buyboxCtaSentinel" aria-hidden="true"></div>
                    <div ref="buyboxCta">
                      <add-to-basket
                        :variation-id="currentVariation.variation.id"
                        :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                        :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                        :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                        :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                        :maximum-quantity="
                          !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                        "
                        :order-properties="
                          currentVariation.properties.filter(function(prop) {
                            return prop.property.isOderProperty;
                          })
                        "
                        :has-order-properties="currentVariation.hasOrderProperties"
                        :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                        :use-large-scale="false"
                        :show-quantity="true"
                        :item-url="currentVariation | itemURL"
                        :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                        :has-price="currentVariation | hasItemDefaultPrice"
                      >
                      </add-to-basket>
                    </div>
                  </div>

                  <div class="w-100">
                    <slot name="after-add-to-basket"></slot>
                  </div>
                </div>

                <!-- ./ITEM DETAIL -->

                <slot name="additional-content-after-add-to-basket"></slot>

                <slot name="additional-content-after-vat"></slot>
              </div>

              <!-- SOCIAL SHARE -->
              <div class="btn btn-block border-radius font-weight-bold p-0 px-3 px-md-0" >
                <a href="javascript:void(0);" id="shareToggle" onclick="toggleShareDiv()">
                  <i class="fa fa-share-alt float-left mr-2" aria-hidden="true"></i>{{ $translate("HuGVueTheme::SingleItemTheme.ShareButton") }}</a
                >
                <div id="shareDiv" class="share-buttons position-absolute border-radius px-3 px-md-0 mt-2">
                  <a id="share-facebook" href="javascript:void(0);" onclick="share('facebook')"> <i class="fa fa-facebook-official" aria-hidden="true"></i> Facebook </a>
                  <a id="share-whatsapp" href="javascript:void(0);" onclick="share('whatsapp')"> <i class="fa fa-whatsapp" aria-hidden="true"></i> WhatsApp </a>
                  <a id="share-email" href="javascript:void(0);" onclick="share('email')"> <i class="fa fa-envelope-o" aria-hidden="true"></i> Email </a>
                </div>
              </div>
              <!-- /SOCIAL SHARE -->

              <div class="fs-my-color-property px-3 px-md-0 mb-2" v-if="getMyColorPropertyValue"><span class="font-weight-bold">Farbe:</span> {{ getMyColorPropertyValue }}</div>

              <slot name="fs-color"></slot>

              <slot name="fs-size-button"></slot>

              <!-- /BuyBox -->

              <easycredit-widget
                v-if="hydrated"
                webshop-id="1.de.12094.1"
                :amount="currentVariation.prices.default.price.value"
                extended="true"
                disable-flexprice="false"
                class="d-none"
              />

              <a :href="$translate('HuGVueTheme::SingleItemTheme.itemBannerLink')" class="item-banner" v-if="$translate('HuGVueTheme::SingleItemTheme.itemBannerImage') !== ''">
                <img :src="$translate('HuGVueTheme::SingleItemTheme.itemBannerImage')" :alt="$translate('HuGVueTheme::SingleItemTheme.itemBannerAlt')" class="img-fluid mt-2 mb-3" />
              </a>

              <!-- Trusted Anchor - disabled for now -->
              <!-- <a href="#trusted-anchor">
                <div class="d-flex t-anchor p-3 border-radius align-items-center mt-4 mb-5 mx-3 mx-md-0">
                  <img :src="$translate('HuGVueTheme::SingleItemTheme.eTrustedAnchorImage')" :alt="$translate('HuGVueTheme::SingleItemTheme.eTrustedAnchorContent')" class="img-fluid mr-3" />
                  <span class="font-weight-bold text-dark">{{ $translate("HuGVueTheme::SingleItemTheme.eTrustedAnchorContent") }}</span>
                </div>
              </a> -->
              <!-- /Trusted Anchor -->

              <!-- /SINGLEITEM_DETAILS -->

              <template v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0">
                <div v-for="variationPropertyGroups in getKeyFactsProperties" :key="variationPropertyGroups.id">
                  <p class="h4 font-weight-bold mb-3 px-3 px-md-0" v-html="$translate('HuGVueTheme::SingleItemTheme.KeyFactsHeadline')"></p>
                  <ul class="list-unstyled m-0 p-0 px-3 px-md-0 mb-5">
                    <li v-for="variationProperty in variationPropertyGroups.properties" :key="variationProperty.id" class="d-flex mb-3">
                      <i class="fa fa-check mr-3 mt-1"></i>
                      <span class="font-weight-bold" v-html="variationProperty.values.value"></span>
                    </li>
                  </ul>
                </div>
              </template>

              <!-- Mobile video button -->
              <template v-if="currentVariation.variationProperties && currentVariation.variationProperties.length > 0">
                <div v-for="variationPropertyGroups in getVideoProperties" :key="variationPropertyGroups.id" class="px-3 px-md-0 mb-3 d-flex d-md-none">
                  <button
                    type="button"
                    class="btn btn-primary fs-video-btn border-radius font-weight-bold d-inline-flex align-items-center w-100 justify-content-center"
                    data-toggle="modal"
                    data-target="#product-video"
                    v-html="$translate('HuGVueTheme::SingleItemTheme.ModalButtonText')"
                  ></button>
                </div>
              </template>

              <p v-for="barcodes in getEanBarcodes" :key="barcodes.id" class="ml-3 ml-md-0 mb-0"><span>EAN: </span>{{ barcodes.code }}</p>
              <template v-if="currentVariation.variation.number != ''">
                <p class="ml-3 ml-md-0 mb-0"><span>SKU: </span>{{ currentVariation.variation.number }}</p>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="single container-fluid bg-primary pt-3" id="itemnav">
        <div
          class="container-max p-0 position-relative single-nav-hints"
          :class="{
            'is-overflowing': singleNavIsOverflowing,
            'can-scroll-left': singleNavCanScrollLeft,
            'can-scroll-right': singleNavCanScrollRight,
          }"
        >
          <ul
            ref="singleNav"
            class="single-nav list-unstyled d-flex justify-content-around m-2"
          >
            <slot name="single-navigation"></slot>
            <li v-if="documentLinks.length" class="d-flex mr-4 pb-3 justify-content-around">
              <a href="#documents" class="text-white font-weight-bold scroll">
                {{ $translate("HuGVueTheme::SingleItemTheme.NavigationDocuments") }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="single container-max page-content addinfo mt-5 mb-3">
        <div class="row position-relative">
          <div class="col-12 col-lg-6 order-1 order-lg-1 d-flex flex-wrap align-self-start">
            <div class="w-100 order-1 order-lg-1">
              <!-- ITEM DESCRIPTION -->
              <p class="m-0" id="itemDesc"></p>
              <div class="item-description-container mb-45">
                <div class="item-description">
                  <div v-html="currentVariation.texts.description"></div>
                </div>
              </div>
              <!-- /ITEM DESCRIPTION -->
            </div>

            <div class="w-100 order-2 order-lg-2">
              <div class="bg-gray p-3 mb-45 border-radius js-show-more" id="techData" data-show-more-height="250">
                <p class="h4 font-weight-bold mb-3 mb-md-0">
                  {{ $translate("Ceres::Template.singleItemTechnicalData") }}
                </p>
                <div class="mt-3 js-show-more-content" v-html="currentVariation.texts.technicalData"></div>
              </div>
            </div>

            <div class="w-100 order-3 order-lg-3">
              <!-- Eigenschaft FAQ -->
              <template>
                <div v-if="filteredVariationPropertyGroups.length && getFAQProperties.length">
                  <p class="m-0" id="faq"></p>
                  <div v-for="variationProperty in getFAQProperties" :key="variationProperty.id" class="fs-faq bg-gray p-3 mb-45 border-radius">
                    <p class="h4 font-weight-bold mb-3">
                      {{ $translate("HuGVueTheme::SingleItemTheme.NavigationFAQ") }}
                    </p>
                    <div v-if="variationProperty.values.value">
                      <div v-html="variationProperty.values.value"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="w-100 order-4 order-lg-4">
              <!-- Eigenschaft Montage -->
              <template>
                <div v-if="filteredVariationPropertyGroups.length && getMontageProperties.length">
                  <p class="m-0" id="montage"></p>
                  <div
                    v-for="variationProperty in getMontageProperties"
                    :key="variationProperty.id"
                    class="fs-montage bg-gray p-3 mb-45 border-radius js-show-more"
                    data-show-more-height="250"
                  >
                    <p class="h4 font-weight-bold mb-3">
                      {{ $translate("HuGVueTheme::SingleItemTheme.NavigationMontage") }}
                    </p>
                    <div v-if="variationProperty.values.value" class="js-show-more-content">
                      <div v-html="variationProperty.values.value"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>

          <div class="col-12 col-lg-6 order-2 order-lg-2 px-0 px-lg-3 d-flex flex-wrap align-self-start">
            <div class="w-100 order-1 order-lg-1">
              <div class="fs-xselling">
                <slot name="cross-selling-accessory"></slot>
              </div>
            </div>

            <div class="w-100 order-2 order-lg-2">
              <div class="fs-xselling">
                <slot name="cross-selling-similar"></slot>
              </div>
            </div>

            <div class="w-100 order-3 order-lg-3">
              <template v-if="documentLinks.length">
                <p class="m-0" id="documents"></p>
                <div class="fs-documents artikeldetailseite-montage-wrapper bg-gray p-3 mb-45 border-radius">
                  <p class="h4 font-weight-bold mb-3">
                    {{ $translate("HuGVueTheme::SingleItemTheme.NavigationDocuments") }}
                  </p>
                  <a
                    v-for="documentLink in documentLinks"
                    :key="documentLink.url"
                    class="adm-doc-link"
                    :href="documentLink.url"
                    target="_blank"
                    rel="noopener"
                  >
                    <img
                      class="adm-doc-icon"
                      src="https://cdn02.plentymarkets.com/6nqf4rd4jwp6/frontend/Hersteller_Logos/Logo_content/hug24-logo-pdf-dokument.png"
                      alt=""
                      loading="lazy"
                      @error="showDocumentIconFallback"
                    />
                    <i class="fa fa-file-pdf-o adm-doc-icon d-none" aria-hidden="true"></i>
                    <span>{{ documentLink.title }}</span>
                  </a>
                </div>
              </template>
            </div>

            <div class="w-100 order-4 order-lg-4">
              <section class="fs-guarantees bg-gray p-3 mb-45 border-radius">
                <h2 class="h4 font-weight-bold mb-3">{{ $translate("HuGVueTheme::SingleItemTheme.GuaranteeHeadline") }}</h2>
                <div class="fs-guarantees__labels">
                  <a
                    v-for="label in guaranteeLabels"
                    :key="label.url"
                    :href="label.url"
                    class="fs-guarantees__preview"
                    target="_blank"
                    rel="noopener"
                    aria-haspopup="dialog"
                    :aria-label="label.title"
                    @click="openGuaranteeLabel(label, $event)"
                  >
                    <img
                      v-if="!guaranteeImageErrors.includes(label.url)"
                      :src="label.url"
                      :alt="label.title"
                      loading="lazy"
                      decoding="async"
                      @error="markGuaranteeImageError(label.url)"
                    />
                    <span v-else class="fs-guarantees__error">
                      {{ label.title }}:
                      {{ $translate("HuGVueTheme::SingleItemTheme.GuaranteeImageError") }}
                    </span>
                  </a>
                </div>
              </section>
            </div>

            <div class="w-100 order-5 order-lg-5">
              <div class="fs-contact bg-gray p-3 mb-45 border-radius">
                <p class="h4 font-weight-bold mb-3">{{ $translate("HuGVueTheme::SingleItemContact.ContactHeadline") }}</p>
                <p v-html="$translate('HuGVueTheme::SingleItemContact.ContactText')"></p>
                <p v-html="$translate('HuGVueTheme::SingleItemContact.ContactTelefon')"></p>
                <p>
                  {{ $translate("HuGVueTheme::SingleItemContact.ContactMail") }}
                  <a :href="contactMailtoHref">{{ contactRecipientEmail }}</a>
                </p>
                <div class="fs-contact-link">
                  <p class="mb-1">{{ $translate("HuGVueTheme::SingleItemContact.ContactLinkTo") }}</p>
                  <a :href="contactMailtoHref" class="btn btn-inline btn-primary btn-appearance border-radius mt-1">
                    {{ $translate("HuGVueTheme::SingleItemContact.ContactLinkButton") }}
                  </a>
                </div>
              </div>
            </div>

            <div class="w-100 order-6 order-lg-6">
              <template>
                <div v-if="filteredVariationPropertyGroups.length && getRangeProperties.length">
                  <p class="m-0" id="range"></p>
                  <div v-for="variationProperty in getRangeProperties" :key="variationProperty.id" class="fs-range bg-gray p-3 mb-45 border-radius">
                    <p class="h4 font-weight-bold mb-3">
                      {{ $translate("HuGVueTheme::SingleItemTheme.NavigationRange") }}
                    </p>
                    <div v-if="variationProperty.values.value">
                      <div v-html="variationProperty.values.value"></div>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <div class="w-100 order-7 order-lg-7">
              <template>
                <div class="fs-manufacturer bg-gray p-3 mb-45 border-radius js-show-more" data-show-more-height="250">
                  <div class="js-show-more-content">
                    <div v-if="filteredVariationPropertyGroups.length && getManufacturerProperties.length">
                      <p class="m-0" id="manufacturer"></p>
                      <div v-for="variationProperty in getManufacturerProperties" :key="variationProperty.id" class="">
                        <p class="h4 font-weight-bold mb-3">{{ $translate("HuGVueTheme::SingleItemTheme.NavigationManufacturer") }}</p>
                        <div v-if="variationProperty.values.value">
                          <div v-html="variationProperty.values.value"></div>
                        </div>
                      </div>
                    </div>
                    <div class="my-4" v-if="isEuResponsibleTabShown">
                      <p class="font-weight-bold">{{ $translate("Ceres::Template.singleItemEuResponsiblePerson") }}</p>
                      <div class="p-0">
                        <span>{{ currentVariation.item.manufacturer.responsibleName }}</span>
                      </div>

                      <div class="p-0">
                        <span>{{ currentVariation.item.manufacturer.responsibleStreet }}</span>
                        <span>{{ currentVariation.item.manufacturer.responsibleHouseNo }}</span>
                      </div>

                      <div class="p-0">
                        <span>{{ currentVariation.item.manufacturer.responsiblePostCode }}</span>
                        <span>{{ currentVariation.item.manufacturer.responsibleTown }}</span>
                        <span v-if="currentVariation.item.manufacturer.responsibleCountryObject">
                          {{ currentVariation.item.manufacturer.responsibleCountryObject.name }}
                        </span>
                      </div>

                      <div class="p-0">
                        <span>{{ currentVariation.item.manufacturer.responsibleEmail }}</span>
                      </div>

                      <div class="p-0">
                        <span>{{ currentVariation.item.manufacturer.responsiblePhoneNo }}</span>
                      </div>

                      <div class="p-0">
                        <span>{{ currentVariation.item.manufacturer.responsibleContactUrl }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div id="trusted-anchor">
          <p class="h4 font-weight-bold mb-3">{{ $translate("HuGVueTheme::SingleItemTheme.eTrustedHeadline") }}</p>
          <div>
            <etrusted-widget data-etrusted-widget-id="wdg-d5a7ecfa-fc6e-4f0d-bd62-c0e1acc3b703"></etrusted-widget>
          </div>
        </div>

        <slot name="item-list-container"></slot>

        <slot name="feedback-container"></slot>

        <transition name="fs-sticky-cart-slide">
          <div class="fs-sticky-cart" v-if="showStickyCart" aria-label="In den Warenkorb">
            <div class="fs-sticky-cart__inner">
              <div class="fs-sticky-cart__thumb" aria-hidden="true">
                <div
                  class="fs-sticky-discount fs-discount-badge d-flex align-items-center justify-content-center text-white font-weight-bold position-absolute border-radius px-1 py-1"
                  v-if="savingMoneyPercent > 0"
                >
                  <span>-{{ Math.floor(savingMoneyPercent) }}%</span>
                </div>
                <img
                  class="border-radius"
                  v-if="currentVariation.images && currentVariation.images.all && currentVariation.images.all.length"
                  :src="currentVariation.images.all[0].urlPreview || currentVariation.images.all[0].urlMiddle || currentVariation.images.all[0].url"
                  :alt="currentVariation | itemName"
                  loading="lazy"
                />
              </div>

              <div class="fs-sticky-cart__meta">
                <div class="fs-sticky-cart__title">{{ currentVariation | itemName }}</div>
                <div class="fs-sticky-cart__price">
                  <item-price :show-cross-price="false"></item-price>
                </div>
              </div>

              <div class="fs-sticky-cart__cta">
                <add-to-basket
                  :variation-id="currentVariation.variation.id"
                  :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                  :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                  :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                  :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                  :maximum-quantity="
                    !!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null
                  "
                  :order-properties="
                    currentVariation.properties.filter(function(prop) {
                      return prop.property.isOderProperty;
                    })
                  "
                  :has-order-properties="currentVariation.hasOrderProperties"
                  :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                  :use-large-scale="false"
                  :show-quantity="false"
                  :item-url="currentVariation | itemURL"
                  :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                  :has-price="currentVariation | hasItemDefaultPrice"
                >
                </add-to-basket>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </slot>
    <div
      ref="guaranteeModal"
      class="modal fs-guarantee-modal"
      tabindex="-1"
      role="dialog"
      aria-modal="true"
      aria-hidden="true"
      :aria-label="activeGuaranteeLabel ? activeGuaranteeLabel.title : $translate('HuGVueTheme::SingleItemTheme.GuaranteeHeadline')"
    >
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title h5">{{ activeGuaranteeLabel ? activeGuaranteeLabel.title : "" }}</h3>
            <button ref="guaranteeModalClose" type="button" class="close" data-dismiss="modal" :aria-label="$translate('HuGVueTheme::SingleItemTheme.ModalClose')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="activeGuaranteeLabel" class="modal-body text-center">
            <p v-if="guaranteeImageErrors.includes(activeGuaranteeLabel.url)" role="status">
              {{ $translate("HuGVueTheme::SingleItemTheme.GuaranteeImageError") }}
            </p>
            <img
              v-else
              :key="activeGuaranteeLabel.url"
              class="fs-guarantee-modal__image"
              :src="activeGuaranteeLabel.url"
              :alt="activeGuaranteeLabel.title"
              @error="markGuaranteeImageError($event.target.src)"
            />
          </div>
          <div v-if="activeGuaranteeLabel" class="modal-footer">
            <a :href="activeGuaranteeLabel.url" target="_blank" rel="noopener">
              {{ $translate("HuGVueTheme::SingleItemTheme.GuaranteeOpenOriginal") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "core-js/web/url";
import { get } from "../../helper/get";
import { isNullOrUndefined } from "../../helper/utils";
import { getTrackingNetPrice, getTrackingPrice, withOptionalPrice, withOptionalNetValue } from "../../helper/tracking";
import { initShowMoreBlocks, refreshShowMoreBlocks } from "../../common/showMore";

export default {
  name: "single-item",

  props: {
    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0,
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false,
    },
    showNetPrices: {
      type: Boolean,
      default: false,
    },
    isWishListEnabled: {
      type: Boolean,
      default: false,
    },
    legalGuaranteeImageUrl: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
    afterKey: Object,
  },

  jsonDataFields: ["itemData", "attributesData", "variations"],

  provide() {
    return {
      itemId: this.$props.itemId,
    };
  },
  computed: {
    canUseStickyCart() {
      const variation = this.currentVariation;
      return !!(variation && variation.filter && variation.filter.isSalable && variation.item && variation.item.itemType !== "set");
    },
    showStickyCart() {
      return this.canUseStickyCart && this.buyboxCtaAboveViewport && !this.buyboxCtaInView;
    },
    isUsp4Visible() {
      const categories = Array.isArray(this.currentVariation?.defaultCategories) ? this.currentVariation.defaultCategories : [];

      return categories[0]?.id === 206 || categories[0]?.id === 45 || categories[1]?.id === 206 || categories[1]?.id === 45;
    },
    savingMoneyPercent() {
      const hasPrice =
        !!this.currentVariation.prices.rrp &&
        ((this.currentVariation.prices.rrp.unitPrice.value - this.currentVariation.prices.default.price.value) / this.currentVariation.prices.rrp.unitPrice.value) * 100;
      return hasPrice;
    },
    campaignBadgeValue() {
      const groups = this.currentVariation?.variationProperties || [];
      for (const group of groups) {
        if (!group.properties) {
          continue;
        }

        const badge = group.properties.find((prop) => prop.id === 323 && prop.values && prop.values.value);
        if (badge) {
          return badge.values.value;
        }
      }

      return "";
    },
    hasVariationProperties() {
      return this.currentVariation.variationProperties && this.currentVariation.variationProperties.length > 0;
    },
    filteredVariationPropertyGroups() {
      return this.currentVariation.variationProperties.filter((group) => group.id === 34);
    },
    itemConfig() {
      return App.config.item.itemData;
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.description.length;
    },
    isEuResponsibleTabShown() {
      return (
        this.currentVariation.item.manufacturer.responsibleEmail !== "" ||
        this.currentVariation.item.manufacturer.responsibleHouseNo !== "" ||
        this.currentVariation.item.manufacturer.responsibleName !== "" ||
        this.currentVariation.item.manufacturer.responsiblePhoneNo !== "" ||
        this.currentVariation.item.manufacturer.responsiblePostCode !== "" ||
        this.currentVariation.item.manufacturer.responsibleStreet !== "" ||
        this.currentVariation.item.manufacturer.responsibleTown !== "" ||
        this.currentVariation.item.manufacturer.responsibleContactUrl !== "" ||
        this.currentVariation.item.manufacturer.responsibleCountry !== 0
      );
    },
    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) && !!this.currentVariation.texts.technicalData.length;
    },

    guaranteeLabelUrl() {
      const variation = this.currentVariation || {};
      const groups = Array.isArray(variation.variationProperties) ? variation.variationProperties : [];
      const variationProperties = get(variation, "variation.properties");
      const properties = Array.isArray(variationProperties) ? variationProperties.slice() : [];

      for (const group of groups) {
        if (group && Array.isArray(group.properties)) {
          properties.push(...group.properties);
        } else {
          properties.push(group);
        }
      }
      if (Array.isArray(variation.properties)) {
        properties.push(...variation.properties);
      }

      for (const property of properties) {
        const propertyId = get(property, "propertyId") || get(property, "property.id") || get(property, "id");
        if (Number(propertyId) !== 627) {
          continue;
        }

        for (const value of [get(property, "values.value"), get(property, "property.value"), get(property, "value")]) {
          const url = this.normalizeGuaranteeImageUrl(value);
          if (url) {
            return url;
          }
        }
      }
      return "";
    },

    guaranteeLabels() {
      const labels = [];
      if (this.guaranteeLabelUrl) {
        labels.push({
          url: this.guaranteeLabelUrl,
          title: this.$translate("HuGVueTheme::SingleItemTheme.GuaranteeLabelTitle"),
        });
      }
      labels.push({
        url: this.legalGuaranteeImageUrl,
        title: this.$translate("HuGVueTheme::SingleItemTheme.LegalGuaranteeTitle"),
      });
      return labels;
    },

    documentLinks() {
      const documentLinks = [];
      const seenUrls = {};
      const sourceHtml = this.getDocumentSourceHtml();

      for (const html of sourceHtml) {
        if (typeof html !== "string" || !this.hasDocumentHint(html)) {
          continue;
        }

        for (const documentLink of this.extractDocumentLinks(html)) {
          const normalizedUrl = this.normalizeDocumentUrl(documentLink.url);

          if (!normalizedUrl || seenUrls[normalizedUrl]) {
            continue;
          }

          seenUrls[normalizedUrl] = true;
          documentLinks.push({
            url: normalizedUrl,
            title: this.getDocumentTitle(normalizedUrl, documentLink.title),
          });
        }
      }

      return documentLinks;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    contactItemName() {
      const variation = this.currentVariation;
      if (!variation) {
        return "";
      }

      return (
        (this.$options.filters && this.$options.filters.itemName
          ? this.$options.filters.itemName(variation)
          : null)
        || get(variation, "texts.name1")
        || ""
      );
    },

    contactItemUrl() {
      if (this.$options.filters && this.$options.filters.itemURL && this.currentVariation) {
        const relativeUrl = this.$options.filters.itemURL(this.currentVariation);

        if (relativeUrl) {
          if (typeof window !== "undefined" && window.location && window.location.origin) {
            return `${window.location.origin}${relativeUrl}`;
          }

          return relativeUrl;
        }
      }

      if (typeof window !== "undefined" && window.location && window.location.href) {
        return window.location.href;
      }

      return "";
    },

    contactRecipientEmail() {
      return "service@heimundgarten24.de";
    },

    contactMailtoHref() {
      const itemName = (this.contactItemName || "").trim();
      const itemUrl = this.contactItemUrl;
      const hasItemName = itemName.length > 0;
      const subject = hasItemName
        ? this.$translate("HuGVueTheme::SingleItemContact.ContactMailtoSubject", { itemName })
        : this.$translate("HuGVueTheme::SingleItemContact.ContactMailtoSubjectGeneric");
      const body = this.$translate(
        hasItemName
          ? "HuGVueTheme::SingleItemContact.ContactMailtoBody"
          : "HuGVueTheme::SingleItemContact.ContactMailtoBodyGeneric",
        {
          itemName,
          itemUrl: itemUrl || "",
          lineBreak: "\n",
        }
      );

      return `mailto:${this.contactRecipientEmail}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    hasPrimaryVariationSelector() {
      const attributeCount = Array.isArray(this.attributes) ? this.attributes.length : 0;
      const unitCount = this.units && typeof this.units === "object" ? Object.keys(this.units).length : 0;

      return attributeCount > 0 || unitCount > 0;
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    },

    // Computed properties for filtered data to avoid v-for/v-if issues
    getBadgeProperties() {
      if (!this.currentVariation.variationProperties) return [];
      return this.currentVariation.variationProperties.filter((group) => group.id === 34);
    },

    getVideoProperties() {
      if (!this.currentVariation.variationProperties) return [];
      return this.currentVariation.variationProperties.filter(
        (group) => group.id === 35 && Array.isArray(group.properties) && group.properties.some((prop) => prop.values && prop.values.value)
      );
    },

    getKeyFactsProperties() {
      if (!this.currentVariation.variationProperties) return [];
      return this.currentVariation.variationProperties.filter((group) => group.id === 8);
    },

    getEanBarcodes() {
      if (!this.currentVariation.barcodes) return [];
      return this.currentVariation.barcodes.filter((barcode) => barcode.name === "EAN");
    },

    // Additional computed properties for specific property IDs
    getMontageProperties() {
      if (!this.currentVariation.variationProperties) return [];
      const properties = [];
      for (const group of this.currentVariation.variationProperties) {
        if (group.properties) {
          properties.push(...group.properties.filter((prop) => prop.id === 239));
        }
      }
      return properties;
    },

    getFAQProperties() {
      if (!this.currentVariation.variationProperties) return [];
      const properties = [];
      for (const group of this.currentVariation.variationProperties) {
        if (group.properties) {
          properties.push(...group.properties.filter((prop) => prop.id === 240));
        }
      }
      return properties;
    },

    getManufacturerProperties() {
      if (!this.currentVariation.variationProperties) return [];
      const properties = [];
      for (const group of this.currentVariation.variationProperties) {
        if (group.properties) {
          properties.push(...group.properties.filter((prop) => prop.id === 238));
        }
      }
      return properties;
    },

    //    getVariationProperties() {
    //      if (this.currentVariation?.variationProperties) {
    //      for (let property of this.currentVariation.variationProperties) {
    //          if (property.properties) {
    //            const result = property.properties.find((prop) => prop.id === 304);
    //            if (result?.values && result.values.value) {
    //              // Werte als Array zurückgeben
    //              return result.values.value.split(",").map((v) => v.trim());
    //            }
    //          }
    //        }
    //      }
    //      return false;
    //    },

    getRangeProperties() {
      if (!this.currentVariation.variationProperties) return [];
      const properties = [];
      for (const group of this.currentVariation.variationProperties) {
        if (group.properties) {
          properties.push(...group.properties.filter((prop) => prop.id === 241));
        }
      }
      return properties;
    },

    // Helper method to get specific properties by ID
    getPropertiesById(groupId, propertyId) {
      if (!this.currentVariation.variationProperties) return [];
      const group = this.currentVariation.variationProperties.find((group) => group.id === groupId);
      if (!group || !group.properties) return [];
      return group.properties.filter((prop) => prop.id === propertyId);
    },

    getMyColorPropertyValue() {
      if (!this.currentVariation.variationProperties) return "";
      for (const group of this.currentVariation.variationProperties) {
        if (group.id === 43 && group.properties) {
          const colorProp = group.properties.find((prop) => prop.id === 305);
          if (colorProp && colorProp.values && colorProp.values.value) {
            return colorProp.values.value;
          }
        }
      }
      return "";
    },

    availabilityDisplayText() {
      const availabilityId = Number(get(this.currentVariation, "variation.availability.id"));
      const translationKey = availabilityId >= 1 && availabilityId <= 10 ? `HuGVueTheme::ItemAvailability.Availability${availabilityId}` : null;

      if (!translationKey) {
        return get(this.currentVariation, "variation.availability.names.name") || "";
      }

      const translatedText = this.$translate(translationKey);
      return availabilityId === 4 ? this.formatAvailabilityText(translatedText) : translatedText;
    },

  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  data() {
    return {
      activeGuaranteeLabel: null,
      guaranteeImageErrors: [],
      tallyScriptInitialized: false,
      buyboxCtaInView: true,
      buyboxCtaAboveViewport: false,
      lastTrackedViewItemKey: null,
      hydrated: false,
      stickyCartFallbackHandler: null,
      stickyCartFallbackRafId: null,
      variationChangedHandler: null,
      ecClickHandler: null,
      singleNavIsOverflowing: false,
      singleNavCanScrollLeft: false,
      singleNavCanScrollRight: false,
      singleNavScrollHandler: null,
      singleNavWindowResizeHandler: null,
      singleNavResizeObserver: null,
      singleNavMutationObserver: null,
      singleNavRafId: null,
    };
  },

  mounted() {
    this.hydrated = true;
    this.initGuaranteeModal();
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey,
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }

      this.initStickyCartTrigger();
      this.initSingleNavScrollHints();
      initShowMoreBlocks(this.$el);
    });

    // toggleDescription entfällt, da jetzt Vue-Mechanik genutzt wird

    // listen for variation change to hydrate all children lazy-hydrate components
    if (typeof document !== "undefined") {
      this.variationChangedHandler = () => this.hydrateChildren(this.$children);
      document.addEventListener("onVariationChanged", this.variationChangedHandler);
    }

    this.initTallyEmbed();
    this.initEasycreditOpen();
    this.pushViewItemDataLayer();
  },

  beforeDestroy() {
    this.destroyGuaranteeModal();
    if (typeof document !== "undefined" && this.variationChangedHandler) {
      document.removeEventListener("onVariationChanged", this.variationChangedHandler);
      this.variationChangedHandler = null;
    }

    this.destroyStickyCartTrigger();
    this.destroyEasycreditOpen();
    this.destroySingleNavScrollHints();
  },

  methods: {
    normalizeGuaranteeImageUrl(value) {
      if (typeof value !== "string" || !value.trim()) {
        return "";
      }
      try {
        const url = new URL(value.trim());
        return (url.protocol === "https:" || url.protocol === "http:") && !url.username && !url.password ? url.href : "";
      } catch (error) {
        return "";
      }
    },

    markGuaranteeImageError(url) {
      if (!this.guaranteeImageErrors.includes(url)) {
        this.guaranteeImageErrors.push(url);
      }
    },

    initGuaranteeModal() {
      if (!window.jQuery || !window.jQuery.fn.modal || !this.$refs.guaranteeModal) {
        return;
      }
      this.guaranteeModal = window.jQuery(this.$refs.guaranteeModal);
      this.guaranteeModal.on("shown.bs.modal.hgGuarantee", () => {
        if (this.$refs.guaranteeModalClose) {
          this.$refs.guaranteeModalClose.focus();
        }
      });
      this.guaranteeModal.on("hidden.bs.modal.hgGuarantee", () => {
        this.activeGuaranteeLabel = null;
        const trigger = this.guaranteeModalTrigger;
        this.guaranteeModalTrigger = null;
        if (trigger && document.documentElement.contains(trigger) && trigger.getClientRects().length) {
          trigger.focus();
        }
      });
    },

    openGuaranteeLabel(label, event) {
      // Preserve the direct image link when Bootstrap is unavailable or a new tab is requested.
      if (!this.guaranteeModal || event.button > 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
        return;
      }
      event.preventDefault();
      this.guaranteeModalTrigger = event.currentTarget;
      this.activeGuaranteeLabel = label;
      this.$nextTick(() => {
        if (this.guaranteeModal && this.activeGuaranteeLabel) {
          this.guaranteeModal.modal("show");
        }
      });
    },

    closeGuaranteeModal() {
      if (this.guaranteeModal) {
        this.guaranteeModal.modal("hide");
      }
      this.activeGuaranteeLabel = null;
    },

    destroyGuaranteeModal() {
      if (this.guaranteeModal) {
        this.guaranteeModal.off(".hgGuarantee").modal("hide").modal("dispose");
        this.guaranteeModal = null;
      }
      this.guaranteeModalTrigger = null;
    },

    getDocumentSourceHtml() {
      const variation = this.currentVariation || {};
      const texts = variation.texts || {};
      const sourceHtml = [
        texts.description,
        texts.shortDescription,
        texts.technicalData,
      ];

      const variationPropertyGroups = Array.isArray(variation.variationProperties) ? variation.variationProperties : [];
      for (const group of variationPropertyGroups) {
        const properties = Array.isArray(group.properties) ? group.properties : [];

        for (const property of properties) {
          sourceHtml.push(
            get(property, "values.value"),
            property.value,
            get(property, "names.description"),
            get(property, "property.names.description")
          );
        }
      }

      const properties = Array.isArray(variation.properties) ? variation.properties : [];
      for (const property of properties) {
        sourceHtml.push(
          get(property, "values.value"),
          property.value,
          get(property, "property.value"),
          get(property, "property.names.description")
        );
      }

      return sourceHtml.filter((html) => typeof html === "string" && html.length > 0);
    },

    hasDocumentHint(html) {
      const normalizedHtml = String(html || "").toLowerCase();

      return (
        normalizedHtml.includes(".pdf")
        || normalizedHtml.includes("heyzine.com/flip-book/")
        || normalizedHtml.includes("hug24-logo-pdf-dokument")
      );
    },

    extractDocumentLinks(html) {
      const links = [];
      const anchorRegex = /<a\b[^>]*\bhref\s*=\s*(?:"([^"]+)"|'([^']+)'|([^\s>]+))[^>]*>([\s\S]*?)<\/a>/gi;
      const plainUrlRegex = /(?:https?:\/\/|\/)[^\s"'<>]+\.pdf(?:[?#][^\s"'<>]*)?|https?:\/\/(?:www\.)?heyzine\.com\/flip-book\/[^\s"'<>]+/gi;
      let match;

      while ((match = anchorRegex.exec(html)) !== null) {
        const url = match[1] || match[2] || match[3];
        const content = match[4];

        if (!this.isDocumentUrl(url) && (!this.hasDocumentIcon(content) || this.isDocumentAssetUrl(url))) {
          continue;
        }

        links.push({
          url,
          title: this.getDocumentLinkTitle(content),
        });
      }

      while ((match = plainUrlRegex.exec(html)) !== null) {
        links.push({
          url: match[0],
          title: "",
        });
      }

      return links;
    },

    isDocumentUrl(url) {
      const normalizedUrl = this.normalizeDocumentUrl(url);

      return (
        /\.pdf(?:[?#]|$)/i.test(normalizedUrl)
        || /^https?:\/\/(?:www\.)?heyzine\.com\/flip-book\/[^"'<>\s]+/i.test(normalizedUrl)
      );
    },

    hasDocumentIcon(html) {
      return /hug24-logo-pdf-dokument|pdf dokument/i.test(String(html || ""));
    },

    isDocumentAssetUrl(url) {
      return /\.(?:png|jpe?g|webp|svg|gif)(?:[?#]|$)/i.test(this.normalizeDocumentUrl(url));
    },

    normalizeDocumentUrl(url) {
      return this.decodeHtmlEntities(String(url || ""))
        .trim()
        .replace(/[.,;)\]]+$/g, "");
    },

    getDocumentTitle(url, title) {
      const cleanedTitle = this.decodeHtmlEntities(String(title || "")).trim();

      if (cleanedTitle) {
        return cleanedTitle;
      }

      const filename = url
        .split(/[?#]/)[0]
        .split("/")
        .pop()
        .replace(/\.(?:pdf|html?)$/i, "")
        .replace(/[-_]+/g, " ")
        .trim();

      if (filename) {
        try {
          return decodeURIComponent(filename);
        } catch (error) {
          return filename;
        }
      }

      return this.$translate("HuGVueTheme::SingleItemTheme.DocumentLinkFallback");
    },

    getDocumentLinkTitle(html) {
      const textTitle = this.stripHtml(html);
      const imageTitle = this.getImageDocumentTitle(html);

      return textTitle || imageTitle;
    },

    getImageDocumentTitle(html) {
      const imageRegex = /<img\b[^>]*(?:\balt|\btitle)\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]*))[^>]*>/gi;
      let match;

      while ((match = imageRegex.exec(String(html || ""))) !== null) {
        const title = this.decodeHtmlEntities(match[1] || match[2] || match[3] || "")
          .replace(/\s+/g, " ")
          .trim();

        if (title) {
          return title;
        }
      }

      return "";
    },

    stripHtml(value) {
      return this.decodeHtmlEntities(String(value || ""))
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    },

    decodeHtmlEntities(value) {
      return String(value || "")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&quot;/gi, "\"")
        .replace(/&#39;/g, "'")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">");
    },

    showDocumentIconFallback(event) {
      const image = event && event.target;
      const fallbackIcon = image && image.nextElementSibling;

      if (image) {
        image.classList.add("d-none");
      }

      if (fallbackIcon) {
        fallbackIcon.classList.remove("d-none");
      }
    },

    getCategoryLabel(category) {
      return (
        get(category, "details.name")
        || get(category, "details.0.name")
        || get(category, "name")
        || ""
      );
    },

    getViewItemCategoryName(variation) {
      const defaultCategories = Array.isArray(variation.defaultCategories) ? variation.defaultCategories : [];
      const defaultCategoryName = this.getCategoryLabel(defaultCategories[0]);

      if (defaultCategoryName) {
        return defaultCategoryName;
      }

      const breadcrumbList = this.$store && this.$store.getters && Array.isArray(this.$store.getters.breadcrumbs)
        ? this.$store.getters.breadcrumbs
        : [];
      const breadcrumbName = this.getCategoryLabel(breadcrumbList[breadcrumbList.length - 1]);

      if (breadcrumbName) {
        return breadcrumbName;
      }

      const currentCategoryName = this.getCategoryLabel(
        this.$store && this.$store.state && this.$store.state.navigation
          ? this.$store.state.navigation.currentCategory
          : null
      );

      return currentCategoryName || "";
    },

    buildViewItemDataLayerItem() {
      const variation = this.currentVariation || {};
      const variationData = variation.variation || {};
      const manufacturer = variation.item && variation.item.manufacturer ? variation.item.manufacturer : {};
      const categoryName = this.getViewItemCategoryName(variation);

      const attributes = Array.isArray(variation.attributes) ? variation.attributes : [];
      const attributeValues = attributes
        .map((attribute) => attribute && attribute.value && attribute.value.names ? attribute.value.names.name : null)
        .filter((value) => !!value);

      const itemVariant =
        (variationData.name && String(variationData.name).trim())
        || (attributeValues.length ? attributeValues.join(" / ") : "");

      const itemId = variationData.number || variationData.id || this.itemId;
      const itemName =
        (this.$options.filters && this.$options.filters.itemName ? this.$options.filters.itemName(variation) : null)
        || (variation.texts && (variation.texts.name1 || variation.texts.name))
        || String(itemId);
      const itemPrice = getTrackingPrice(
        variation.prices && variation.prices.default
      );

      return withOptionalPrice({
        item_id: String(itemId),
        item_name: itemName,
        item_brand: manufacturer.name || manufacturer.externalName || "",
        item_category: categoryName,
        item_variant: itemVariant,
        quantity: 1,
      }, itemPrice);
    },

    pushViewItemDataLayer() {
      if (typeof window === "undefined" || !this.currentVariation || !this.currentVariation.variation) {
        return;
      }

      const variation = this.currentVariation.variation;
      const currentTrackingKey = String(variation.id || variation.number || this.itemId);

      if (this.lastTrackedViewItemKey === currentTrackingKey) {
        return;
      }

      const dataLayerItem = this.buildViewItemDataLayerItem();
      const currency =
        (this.currentVariation
          && this.currentVariation.prices
          && this.currentVariation.prices.default
          && this.currentVariation.prices.default.currency)
        || (window.App && window.App.currency)
        || "EUR";

      const netPrice = getTrackingNetPrice(
        this.currentVariation.prices && this.currentVariation.prices.default,
        this.showNetPrices
      );
      const payload = withOptionalNetValue({
        currency,
        items: [dataLayerItem],
      }, typeof netPrice === "number" ? Number(netPrice) : null);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "view_item",
        ecommerce: payload,
      });
      window.dataLayer.push({
        event: "ecommerceEvent",
        event_name: "view_item",
        ecommerce: payload,
      });

      this.lastTrackedViewItemKey = currentTrackingKey;
    },

    updateBuyboxViewportState() {
      if (typeof window === "undefined") {
        return;
      }

      const buyboxEl = this.$refs.buyboxCta;
      const sentinelEl = this.$refs.buyboxCtaSentinel;
      const triggerEl = sentinelEl || buyboxEl;

      if (!triggerEl) {
        return;
      }

      const targetRect = triggerEl.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      if (buyboxEl) {
        const buyboxRect = buyboxEl.getBoundingClientRect();
        this.buyboxCtaInView = buyboxRect.bottom > 0 && buyboxRect.top < viewportHeight;
      } else {
        this.buyboxCtaInView = targetRect.bottom > 0 && targetRect.top < viewportHeight;
      }

      this.buyboxCtaAboveViewport = targetRect.top <= 0;
    },

    initStickyCartTrigger() {
      if (typeof window === "undefined") {
        return;
      }

      const buyboxEl = this.$refs.buyboxCta;
      const sentinelEl = this.$refs.buyboxCtaSentinel;

      if (!buyboxEl && !sentinelEl) {
        return;
      }

      this.stickyCartFallbackHandler = () => {
        if (this.stickyCartFallbackRafId) {
          return;
        }

        this.stickyCartFallbackRafId = window.requestAnimationFrame(() => {
          this.stickyCartFallbackRafId = null;
          this.updateBuyboxViewportState();
        });
      };

      window.addEventListener("scroll", this.stickyCartFallbackHandler, { passive: true });
      window.addEventListener("resize", this.stickyCartFallbackHandler);
      window.addEventListener("orientationchange", this.stickyCartFallbackHandler);

      this.stickyCartFallbackHandler();
      window.setTimeout(() => this.updateBuyboxViewportState(), 0);
    },

    destroyStickyCartTrigger() {
      if (typeof window !== "undefined" && this.stickyCartFallbackHandler) {
        window.removeEventListener("scroll", this.stickyCartFallbackHandler);
        window.removeEventListener("resize", this.stickyCartFallbackHandler);
        window.removeEventListener("orientationchange", this.stickyCartFallbackHandler);
        this.stickyCartFallbackHandler = null;
      }

      if (typeof window !== "undefined" && this.stickyCartFallbackRafId) {
        window.cancelAnimationFrame(this.stickyCartFallbackRafId);
        this.stickyCartFallbackRafId = null;
      }
    },

    queueSingleNavStateUpdate() {
      if (typeof window === "undefined") {
        return;
      }

      if (this.singleNavRafId) {
        return;
      }

      this.singleNavRafId = window.requestAnimationFrame(() => {
        this.singleNavRafId = null;
        this.updateSingleNavScrollState();
      });
    },

    updateSingleNavScrollState() {
      const singleNav = this.$refs.singleNav;
      if (!singleNav) {
        return;
      }

      const maxScrollLeft = Math.max(singleNav.scrollWidth - singleNav.clientWidth, 0);
      const isOverflowing = maxScrollLeft > 1;
      const canScrollLeft = isOverflowing && singleNav.scrollLeft > 1;
      const canScrollRight = isOverflowing && singleNav.scrollLeft < maxScrollLeft - 1;

      this.singleNavIsOverflowing = isOverflowing;
      this.singleNavCanScrollLeft = canScrollLeft;
      this.singleNavCanScrollRight = canScrollRight;
    },

    initSingleNavScrollHints() {
      if (typeof window === "undefined") {
        return;
      }

      const singleNav = this.$refs.singleNav;
      if (!singleNav) {
        return;
      }

      this.singleNavScrollHandler = () => {
        this.queueSingleNavStateUpdate();
      };

      singleNav.addEventListener("scroll", this.singleNavScrollHandler, { passive: true });

      if (typeof ResizeObserver !== "undefined") {
        this.singleNavResizeObserver = new ResizeObserver(() => {
          this.queueSingleNavStateUpdate();
        });
        this.singleNavResizeObserver.observe(singleNav);
      } else {
        this.singleNavWindowResizeHandler = () => {
          this.queueSingleNavStateUpdate();
        };
        window.addEventListener("resize", this.singleNavWindowResizeHandler);
      }

      if (typeof MutationObserver !== "undefined") {
        this.singleNavMutationObserver = new MutationObserver(() => {
          this.queueSingleNavStateUpdate();
        });
        this.singleNavMutationObserver.observe(singleNav, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      this.queueSingleNavStateUpdate();
      window.setTimeout(() => this.queueSingleNavStateUpdate(), 0);
    },

    destroySingleNavScrollHints() {
      const singleNav = this.$refs.singleNav;

      if (singleNav && this.singleNavScrollHandler) {
        singleNav.removeEventListener("scroll", this.singleNavScrollHandler);
      }
      this.singleNavScrollHandler = null;

      if (this.singleNavResizeObserver) {
        this.singleNavResizeObserver.disconnect();
        this.singleNavResizeObserver = null;
      }

      if (typeof window !== "undefined" && this.singleNavWindowResizeHandler) {
        window.removeEventListener("resize", this.singleNavWindowResizeHandler);
        this.singleNavWindowResizeHandler = null;
      }

      if (this.singleNavMutationObserver) {
        this.singleNavMutationObserver.disconnect();
        this.singleNavMutationObserver = null;
      }

      if (typeof window !== "undefined" && this.singleNavRafId) {
        window.cancelAnimationFrame(this.singleNavRafId);
        this.singleNavRafId = null;
      }
    },

    initTallyEmbed() {
      if (this.tallyScriptInitialized || typeof window === "undefined" || typeof document === "undefined") {
        return;
      }

      const isPergolaFinder = /\/(de\/|en\/)?pergola-finder(\/|$)/.test(window.location.pathname);
      if (!isPergolaFinder) {
        return;
      }

      this.tallyScriptInitialized = true;

      const loadTally = () => {
        if (window.Tally && typeof window.Tally.loadEmbeds === "function") {
          window.Tally.loadEmbeds();
          const placeholder = document.getElementById("tally-consent-placeholder");
          if (placeholder) {
            placeholder.remove();
          }
          return true;
        }
        return false;
      };

      const start = () => {
        if (!document.querySelector("iframe[data-tally-src]")) {
          document.addEventListener("DOMContentLoaded", start, { once: true });
          return;
        }

        if (loadTally()) {
          return;
        }

        if (document.querySelector('script[src="https://tally.so/widgets/embed.js"]')) {
          setTimeout(loadTally, 0);
          return;
        }

        const script = document.createElement("script");
        script.src = "https://tally.so/widgets/embed.js";
        script.onload = loadTally;
        script.onerror = () => {
          const fallbackFrame = document.querySelector('iframe[data-tally-src]:not([src])');
          if (fallbackFrame) {
            fallbackFrame.src = fallbackFrame.dataset.tallySrc;
          }
          const placeholder = document.getElementById("tally-consent-placeholder");
          if (placeholder) {
            placeholder.remove();
          }
        };
        document.head.appendChild(script);
      };

      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", start, { once: true });
      } else {
        start();
      }
    },

    initEasycreditOpen() {
      if (typeof document === "undefined") {
        return;
      }

      const tryOpenEasyCredit = () => {
        const widget = document.querySelector("easycredit-widget");
        if (!widget) {
          return false;
        }

        const btn =
          widget.shadowRoot?.querySelector(
            "button.ec-widget__link, button.ec-widget__cta, a.ec-widget__link, a.ec-widget__cta"
          ) ||
          widget.querySelector("button.ec-widget__link, button.ec-widget__cta, a.ec-widget__link, a.ec-widget__cta");

        if (!btn) {
          return false;
        }
        btn.click();
        return true;
      };

      this.ecClickHandler = (event) => {
        const trigger = event.target.closest("[data-ec-open]");
        if (!trigger) {
          return;
        }

        event.preventDefault();

        if (tryOpenEasyCredit()) {
          return;
        }

        const start = performance.now();
        const observer = new MutationObserver(() => {
          if (tryOpenEasyCredit() || performance.now() - start > 3000) {
            observer.disconnect();
          }
        });

        observer.observe(document.documentElement, { childList: true, subtree: true });
      };

      document.addEventListener("click", this.ecClickHandler);
    },

    destroyEasycreditOpen() {
      if (this.ecClickHandler && typeof document !== "undefined") {
        document.removeEventListener("click", this.ecClickHandler);
        this.ecClickHandler = null;
      }
    },

    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }

      return this.getDataField(field);
    },

    getAvailabilityProperty396Value() {
      const normalize = (value) => (typeof value === "string" ? value.trim() : "");

      const variationGroups = Array.isArray(get(this.currentVariation, "variationProperties")) ? this.currentVariation.variationProperties : [];

      for (const group of variationGroups) {
        const groupProperties = Array.isArray(group && group.properties) ? group.properties : [];
        const property396 = groupProperties.find((entry) => Number(get(entry, "id")) === 396);

        if (property396) {
          const value = normalize(get(property396, "values.value") || get(property396, "value") || get(property396, "property.value"));

          if (value) {
            return value;
          }
        }
      }

      const properties = Array.isArray(get(this.currentVariation, "properties")) ? this.currentVariation.properties : [];
      const property396 = properties.find((entry) => Number(get(entry, "propertyId")) === 396);
      return normalize(get(property396, "values.value") || get(property396, "property.value") || get(property396, "value"));
    },

    formatAvailabilityText(text) {
      if (typeof text !== "string") {
        return text;
      }

      const match = text.match(/^(.*?)(\d.*)$/);
      if (match && match[1] && match[2]) {
        const prefix = match[1].trim();
        const suffix = match[2].trim();

        if (prefix && suffix) {
          return `${prefix}<br>${suffix}`;
        }
      }

      return text;
    },

    // iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach((component) => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      });
    },
  },

  watch: {
    guaranteeLabelUrl() {
      this.closeGuaranteeModal();
      this.guaranteeImageErrors = [];
    },
    "currentVariation.variation.id"() {
      this.closeGuaranteeModal();
      this.guaranteeImageErrors = [];
      this.pushViewItemDataLayer();
      this.$nextTick(() => {
        this.queueSingleNavStateUpdate();
        refreshShowMoreBlocks(this.$el);
      });
    },
  },
};
</script>
